import React from 'react'
import { Field } from 'redux-form'
import { Checkbox } from 'loankeeper-common/components'

class CheckboxField extends React.Component {
  handleCheckboxChange = (value) => {
    const { input, customOnChange, indeterminable } = this.props

    if (indeterminable) {
      input.onChange(value)
    } else {
      input.onChange(value ? '1' : '0')
    }

    if (customOnChange) customOnChange(value)
  }

  handleBlur = (e) => e.preventDefault()

  render() {
    const { input, className, disabled, label, indeterminable, defaultChecked, defaultValue } = this.props
    let { value } = input

    if (indeterminable) {
      value = input.value === '' ? defaultValue : Number(input.value)
    } else {
      value = Number(input.value || defaultChecked) === 1
    }

    return (
      <Checkbox
        {...input}
        className={className}
        disabled={disabled}
        label={label ?? ''}
        checked={value}
        onChange={this.handleCheckboxChange}
        onBlur={this.handleBlur}
        indeterminable={indeterminable}
      />
    )
  }
}

const DecoratedField = (props) => <Field {...props} component={CheckboxField} />

export default DecoratedField
